export const iconSizeMap = {
	ExtraSmall: "1rem",
	Small: "1.5rem",
	Default: "1.8rem",
	Large: "2.4rem"
};

export const iconColorMap = {
	Red: "#ff0000",
	Green: "#18bc9c",
	Grey: "#A8A8A8"
};

export enum IconName {
	Delete = "Delete",
	Save = "Save",
	Edit = "Edit",
	Close = "Close",
	Upload = "Upload",
	Done = "Done",
	Loading = "Loading"
};

export enum IconSize {
	ExtraSmall = "ExtraSmall",
	Small = "Small",
	Default = "Default",
	Large = "Large"
};

export enum IconColor {
	Red = "Red",
	Green = "Green",
	Grey = "Grey"
};

export type IconProps = {
	name: IconName
	iconColor?: IconColor
	onClick?: () => void
	iconSize?: IconSize
	disabled?: boolean
	className?: string
};

export type DefaultIconProps = {
	name: IconName;
	iconSize?: IconSize;
	iconColor?: IconColor;
	disabled?: boolean;
	className?: string;
};

export const defaultProps: DefaultIconProps = {
	name: IconName.Loading,
	iconSize: IconSize.Default,
	iconColor: IconColor.Grey,
	disabled: false,
	className: ""
};